import React from 'react';
import Button from 'components/v2/buttons/Button';
import { useErrorBoundary } from 'react-error-boundary';
import CollapsibleItem from 'components/v2/list/CollapsibleItem';
import Card from 'components/v2/panels/Card';
import CircleButton from 'components/v2/buttons/CircleButton';
import { ClipboardIcon } from '@heroicons/react/20/solid';
import CopyToClipboard from 'react-copy-to-clipboard';
import { showToast } from 'stores/ToastStore';
import SessionStore from 'stores/SessionStore';

export default function ErrorPage({ error }) {
  const { resetBoundary } = useErrorBoundary();

  function handleReset() {
    resetBoundary();
  }

  function handleCopy() {
    showToast('Copied Error Message', null, 'info');
  }

  function renderTitle() {
    return (
      <div className="flex items-center">
        <span>{error.message}</span>
      </div>
    );
  }

  return (
    <main className="grid sm:place-items-center px-6 py-24 sm:py-32 lg:px-8 min-h-screen">
      <Card className="">
        <p className="text-base font-semibold text-green-600">500</p>
        <h3 className="my-4">Oops, we ran into a problem!</h3>
        {SessionStore.isAdmin() && (
          <CollapsibleItem renderTitle={renderTitle} defaultOpen>
            <pre className="mt-2">{error.stack}</pre>
            <div className="flex justify-end mt-2">
              <CopyToClipboard text={error.stack} onCopy={handleCopy}>
                <Button
                  color="gray"
                  className="inline-flex space-x-1 items-center text-sm button"
                >
                  <ClipboardIcon className="w-5 h-5 mr-1" />
                  <span>Copy</span>
                </Button>
              </CopyToClipboard>
            </div>
          </CollapsibleItem>
        )}
        <div className="mt-10 flex items-center justify-end sm:gap-x-6 flex-wrap">
          <a
            href="mailto:internalsupport@cargomatic.com"
            className="button button-green mt-4 sm:mt-0"
          >
            Contact support <span aria-hidden="true">&rarr;</span>
          </a>
          <Button onClick={handleReset}>Close</Button>
        </div>
      </Card>
    </main>
  );
}
